import { type FC, type PropsWithChildren } from 'react';
import cn from 'classnames';

import css from './styles.module.scss';

interface SocialWrapperProps extends PropsWithChildren {
  name: 'telegram' | 'x' | 'discord' | 'youtube' | 'instagram' | 'tiktok';
  link?: string;
}

const SocialWrapper: FC<SocialWrapperProps> = ({ name, link, children }) => {
  const handleSocialClick = (): void => {
    if (!link) return;

    if (link.includes('t.me')) {
      Telegram.WebApp.openTelegramLink(link);
    } else {
      Telegram.WebApp.openLink(link);
    }
  };

  return (
    <div
      className={cn(css.socialWrapper, css[`socialWrapper--${name}`])}
      onClick={handleSocialClick}
    >
      {children}
    </div>
  );
};

export { SocialWrapper };
